"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeVariantsForOptionsByProductType = void 0;
const getSizeVariantsForOptionsByProductType = (productType = 'TSHIRT') => {
    let sizes = ['SM', 'MD', 'LG', 'XL', '2Xl', '3XL'];
    switch (productType) {
        case 'MUG': {
            return ['11oz', '15oz'];
        }
        case 'POSTER': {
            return ['8x10', '10x10', '12x12', '11x14', '12x16', '12x18', '14x14', '16x16', '16x20', '18x18', '18x24', '24x36'];
        }
        case 'STAINLESS_STEEL_WATER_BOTTLE': {
            return ['17oz'];
        }
        default: {
            return sizes;
        }
    }
};
exports.getSizeVariantsForOptionsByProductType = getSizeVariantsForOptionsByProductType;
//# sourceMappingURL=getSizeVariantsForOptionsByProductType.js.map